export enum WorkspaceMemberRoleValue {
  OWNER = "owner",
  ADMIN = "admin",
  MEMBER = "member",
}

export enum PaymentStatusValue {
  PAID = "paid",
  PROCESSING = "processing",
}
